import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { LoggedUserContext } from 'context/logged-user/loggeduser.context';
import { useI18n } from 'hooks/useI18n';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledImage,
  StyledTitle
} from './ApplicationsCta.styled';

const ApplicationsCta: React.FC = () => {
  const { t } = useI18n('applications-landing');
  const { locale } = useRouter();

  const { user } = useContext(LoggedUserContext);

  let ctaUrl = `${getAppUrl(APP_URLS.join, locale)}?source=your_apps_profile`;

  if (user) {
    ctaUrl = `${getAppUrl(APP_URLS.portalV2Dashboard, locale)}`;
  }

  return (
    <StyledContainer>
      <StyledImage>
        <img
          src={getPublicPath('/images/applicationsLanding/cta.svg')}
          alt=""
        />
      </StyledImage>
      <StyledTitle>{t('applicationsLanding.cta.title')}</StyledTitle>
      <Link href={ctaUrl} passHref>
        <ButtonLink variant="brandTalent" sizes="md">
          <FontAwesomeIcon icon={faCheckCircle} />
          <span>{t('applicationsLanding.cta.cta')}</span>
        </ButtonLink>
      </Link>
    </StyledContainer>
  );
};

export default ApplicationsCta;
